import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "io-mfe-ig-procedure-table-footer flex",
  style: {"flex-wrap":"nowrap","width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "io-mfe-ig-procedure-table-footer-selected-code-label" }, " Selected Code: ", -1)
const _hoisted_3 = { class: "io-mfe-ig-procedure-table-footer-selected-code" }

import {computed, ref} from 'vue';
import { useSearchStore } from 'stores/search-store';
import { useGrouperStore } from 'stores/grouper-store';
import { useHistoryStore } from 'stores/history-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureTableFooter',
  setup(__props) {

const searchStore = useSearchStore();
const history = useHistoryStore<string>('procedure-history');

const textRef = ref<HTMLElement | null>(null);
const showTooltip = ref(false);

const codeDisplay = computed(() => {
  let display = searchStore.getSelectedProcedureCode;

  for (let i=searchStore.getSelectedProcedureCode.length; i< 7; i++) {
    display += '_';
  }
  return display
});

function checkOverflow() {
  const el = textRef.value;
  if (el) {
    showTooltip.value = el.scrollWidth > el.clientWidth;
  }
}
function hideTooltip() {
  showTooltip.value = false
}

const descriptionDisplay = computed(() => {
  return searchStore.getSelectedProcedureCodeDescription;
});

function startOver() {
  searchStore.setSelectedProcedureCode('');
}

function addCode() {
  useGrouperStore().addProcedureCode(searchStore.getSelectedProcedureCode, undefined, true);
}

const isDisabled = computed(() => searchStore.getSelectedProcedureCode?.length != 7);

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(codeDisplay.value), 1),
    _createElementVNode("span", {
      ref_key: "textRef",
      ref: textRef,
      class: "io-mfe-ig-procedure-table-footer-description",
      onMouseenter: checkOverflow,
      onMouseleave: hideTooltip
    }, [
      _createTextVNode(_toDisplayString(descriptionDisplay.value) + " ", 1),
      _createVNode(_component_q_tooltip, {
        "no-parent-event": "",
        modelValue: showTooltip.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTooltip).value = $event)),
        offset: [0, 3]
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(descriptionDisplay.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 544),
    _createElementVNode("a", {
      class: "io-mfe-ig-procedure-table-footer-start-over",
      onClick: startOver
    }, " Start Over "),
    _createVNode(_component_q_btn, {
      unelevated: "",
      outline: "",
      size: "10px",
      disable: isDisabled.value,
      onClick: addCode,
      class: "io-mfe-ig-procedure-table-footer-add-code"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Add Code ")
      ]),
      _: 1
    }, 8, ["disable"])
  ]))
}
}

})